<b-modal
  v-model="show"
  class="ssm5-full-modal"
  header-text-variant="light"
  no-close-on-backdrop
  no-close-on-esc
  centered
  hide-footer
  hide-header
>
  <template v-slot:default>
    <div :id="contentId" class="full-modal-body" />
  </template>
</b-modal>
